import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "color", "display", "fontSize", "lineHeight", "fontWeight", "letterSpacing", "ellipsis", "rowEllipsis", "textIndent", "textAlign", "textShadow", "userSelect", "verticalAlign", "whiteSpace", "wordWrap", "textDecoration", "textTransform", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* LIBRARIES */
import * as React from 'react';
import { clsx } from 'clsx';
/* STYLES */
import * as styles from '../styles/common.module.css';
import * as displayStyles from '../../../../internal/styles/display.module.css';
import * as typographyStyles from '../../../../typography/sizes.module.css';
import * as userSelectStyles from '../../../../internal/styles/userSelect.module.css';
/* TYPES */

import * as colorsStyles from '@cian/ui-kit-design-tokens/colors/colors.module.css';
import * as deprecatedColorsStyles from '@cian/ui-kit-design-tokens/colors/deprecated/colors.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 *
 * Компонент `Text`. Предназначен для отображения любого текста.
 * <br/>
 * Имеет различные настройки отображения типографики.
 * <br/>
 * Самостоятельное использование текста заприщено.
 */
var TextComponent = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _props$as = props.as,
    as = _props$as === void 0 ? 'span' : _props$as,
    _props$color = props.color,
    color = _props$color === void 0 ? 'text-primary-default' : _props$color,
    _props$display = props.display,
    display = _props$display === void 0 ? 'inline-block' : _props$display,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? '16px' : _props$fontSize,
    _props$lineHeight = props.lineHeight,
    lineHeight = _props$lineHeight === void 0 ? '22px' : _props$lineHeight,
    _props$fontWeight = props.fontWeight,
    fontWeight = _props$fontWeight === void 0 ? 'normal' : _props$fontWeight,
    _props$letterSpacing = props.letterSpacing,
    letterSpacing = _props$letterSpacing === void 0 ? 0 : _props$letterSpacing,
    ellipsis = props.ellipsis,
    rowEllipsis = props.rowEllipsis,
    textIndent = props.textIndent,
    textAlign = props.textAlign,
    textShadow = props.textShadow,
    userSelect = props.userSelect,
    verticalAlign = props.verticalAlign,
    whiteSpace = props.whiteSpace,
    wordWrap = props.wordWrap,
    textDecoration = props.textDecoration,
    textTransform = props.textTransform,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var TagName = as;
  var letterSpacingClassName = styles["text_letterSpacing__".concat(letterSpacing)];
  return /*#__PURE__*/_jsx(TagName, _objectSpread(_objectSpread({}, rest), {}, {
    ref: ref,
    style: {
      letterSpacing: letterSpacingClassName ? null : letterSpacing,
      textShadow: textShadow,
      textIndent: textIndent
    },
    className: clsx(deprecatedColorsStyles["color_".concat(color)], colorsStyles["color_".concat(color)], typographyStyles["lineHeight_".concat(lineHeight)], typographyStyles["fontWeight_".concat(fontWeight)], typographyStyles["fontSize_".concat(fontSize)], displayStyles["display_".concat(display)], styles['text'], styles["fontWeight__".concat(fontWeight)], letterSpacingClassName, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, userSelectStyles["userSelect_".concat(userSelect)], userSelect), styles["text_textDecoration__".concat(textDecoration)], textDecoration), styles["text_textTransform__".concat(textTransform)], textTransform), styles["text_rowEllipsis__".concat(rowEllipsis)], rowEllipsis), styles['text_rowEllipsis'], rowEllipsis), styles['text_ellipsis'], ellipsis), styles["text_textAlign__".concat(textAlign)], textAlign), styles["text_verticalAlign__".concat(verticalAlign)], verticalAlign), styles["text_whiteSpace__".concat(whiteSpace)], whiteSpace), styles["text_wordWrap__".concat(wordWrap)], wordWrap)),
    children: children
  }));
});
TextComponent.displayName = 'Text';
export var Text = /*#__PURE__*/React.memo(TextComponent);